/**
 * Why a game cannot be saved yet, in words, or "" when it can.
 *
 * A disabled button that does not say why is the same failure as a button
 * that does nothing: from outside, both are a control that ignores you. This
 * one sat grey on 1–1 — a draw, which the database refuses and the service
 * refuses and nothing on the screen mentioned — and the honest reading from
 * the other side of it is "I cannot save a singles game".
 *
 * The order matters: it names the FIRST thing missing rather than everything
 * missing, so an empty form says "pick somebody" instead of listing four
 * faults nobody has had a chance to commit yet.
 *
 * Kept beside the rules it mirrors — `games._checked` on the server refuses
 * exactly these, and the point of saying it here is to say it before the
 * round trip, not instead of it.
 */
export function whyNotReady(
  sideA: string[],
  sideB: string[],
  scoreA: string,
  scoreB: string,
): string {
  if (sideA.length === 0 && sideB.length === 0) return 'Pick who played.'
  if (sideA.length === 0) return 'Nobody is on side A yet.'
  if (sideB.length === 0) return 'Nobody is on side B yet.'
  if (scoreA === '' || scoreB === '') return 'Put a score on both sides.'
  // A level score is a DRAW. It used to be refused here and by the database,
  // a rule written for pickleball where 11-11 is somebody's thumb — and wrong
  // for chess, and wrong for the two people who typed one meaning it.
  return ''
}
